module.exports = __webpack_public_path__ + "img/IMG_8906.753e007f.jpg";